export default __webpack_public_path__ + "e79c855313a71c77dcf3ae4f849717dd.eot";